import React from 'react';

export const ArchivedLists = () => {
  return (
    <>
      <ul className="archive-list js-archive-items" />
      <p className="js-empty-message empty-list" />
    </>
  );
};
